export default __webpack_public_path__ + "static/media/image-2.60d09930.png";